module.exports = __webpack_public_path__ + "static/defaultfontsize-f481b8f7f4852f1e7a8cdcf44d5ebe4b.png";